import { OrderDto } from '../order.dto';

export class StandAloneOrderDto {
  order: OrderDto;
  refundOrder: OrderDto;
}